export const RegexHelper = {
  mobilePhoneNumber: /^(([+]46|0)7[02369][\s-]?\d{7})$/, // /^(07[02369][\s-]?\d{7})$/,
  mobilePhoneNumbers: /^(([+]46|0)7[02369][\s-]?\d{7})+([;.](([+]46|0)7[02369][\s-]?\d{7}))*$/, // /^(07[02369][\s-]?\d{7})+([;.](07[02369][\s-]?\d{7}))*$/,
  emailAddress: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  emailAddresses:
    /^(([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/,
  personalNumber: /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{4}$/, // // YYYYMMDDNNNN
  personalNumberWithDash: /^(19|20)\d{2}(0[1-9]|1[0-2])(0[0-9]|[12]\d|3[01])-\d{4}$/, // // YYYYMMDD-NNNN
  clearingNr: /^[0-9]{0,5}$/,
  accountNr: /^[0-9]{0,25}$$/,
};
